import request from '@/utils/request';
//分页查询大连会员数据
export function queryDealerMemberPage(param) {
  return request('/member-report/queryDealerMemberPage', {
    method: 'POST',
    data: param,
  });
}
//获取等级列表
export function getLevels() {
  return request('/config/queryLevels', {
    method: 'GET',
  });
}
